import { Stack } from '@mui/material';
import { FC } from 'react';

const NoRowsOverlay: FC = () => {
  return (
    <Stack direction="row" padding={1} pt={2}>
      No results found.
    </Stack>
  );
};

export default NoRowsOverlay;
